import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export type SearchFileParam = {
  id: string;
  searchId: string;
  field: string;
  value: string;
  date: string;
  type: string;
};

interface FileSearchState {
  searchHistory: SearchFileParam[];
  setSearchHistory: (history: SearchFileParam[]) => void;
  clearSearchHistory: () => void;
  clearSearchHistoryById: (id: string) => void;
}

const storeCreator: StateCreator<FileSearchState> = (set) => ({
  searchHistory: [],
  setSearchHistory: (history: SearchFileParam[]) =>
    set({ searchHistory: history }),
  clearSearchHistory: () => set({ searchHistory: [] }),
  clearSearchHistoryById: (id: string) =>
    set((state) => ({
      searchHistory: state.searchHistory.filter((item) => item.id !== id),
    })),
});

export const useFileSearchStore = create<FileSearchState>()(
  persist(storeCreator, { name: 'file-search-history' }),
);
